import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CompanyInformationComponent } from "../company-information/company-information.component";
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { EditGasInvoiceComponent } from "../../../invoice/components/edit-gas-invoice/edit-gas-invoice.component";
import { InvoiceHelperService } from '../../../../core/services/invoice-helper.service';
import { InvoiceService } from '../../../../core/api/invoice.service';
import { ApiErrorService } from '../../../../core/api/api-error.service';
import { ToastComponent } from '../../../../shared/components/toast/toast.component';
import { CommodityType, GasInvoice, InvoiceGasAndCompanyGet, InvoiceGasPDRGet, InvoiceStatus } from '../../../../core/interfaces/invoice-interfaces';
import { lastValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { Location } from '../../../../core/interfaces/location';
import { FilesService } from '../../../../core/api/files.service';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-admin-review-expanded-gas-invoice',
  standalone: true,
  imports: [CompanyInformationComponent, NgxExtendedPdfViewerModule, CommonModule, TranslocoPipe, EditGasInvoiceComponent],
  templateUrl: './admin-review-expanded-gas-invoice.component.html',
  styleUrl: './admin-review-expanded-gas-invoice.component.css'
})
export class AdminReviewExpandedGasInvoiceComponent implements OnChanges, OnInit {
  constructor(private invoiceHelper: InvoiceHelperService, private invoiceService: InvoiceService, private apiError: ApiErrorService, private filesService: FilesService, private sanitizer: DomSanitizer) { }
  // Toast
  @Input() toast!: ToastComponent;

  @Input() fileUrl?: string;
  @Input() fileId?: string;

  safePdfUrl?: SafeResourceUrl

  CommodityType = CommodityType;

  // Invoice
  @Input() invoice?: InvoiceGasAndCompanyGet;
  @Input() baseInvoice: GasInvoice | null = null;

  summedPDR?: InvoiceGasPDRGet;

  // Locations
  @Input() listOfLocations: Location[] = [];


  // Callback
  @Input() reloadCallbackFunction!: () => void;
  @Input() createLocationSuccessCallbackFunction!: () => void;
  @Input() hardReloadCallbackFunction!: () => void;

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fileId']) {
      if (this.fileId) {
        this.filesService.getPdfUrl(this.fileId).subscribe(response => {
          if (response.download_url) this.safePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(response.download_url);
        });
      }
    }

    if (changes['invoice']) {
      this.baseInvoice = this.invoice as GasInvoice;

      if (this.baseInvoice) {
        this.summedPDR = this.invoiceHelper.getGasInvoicePDRSummed(this.baseInvoice);
      }
    }
  }

  async downloadDisputeReport() {

    // Check if invoice is available
    if (!this.invoice) {
      return
    }

    if (this.invoice.status == InvoiceStatus.CALCULATION_FAILED) {
      this.toast.showToast("shared.error", "invoice.not_enough_data", 'error', 5000, true);
      return;
    }

    // Download report
    try {
      var responseBlob = await lastValueFrom(this.invoiceService.getGasDispute(this.invoice.id ?? ''));

      const blobUrl = URL.createObjectURL(responseBlob);

      window.open(blobUrl, '_blank');
    } catch (error) {
      var crid = 'UNKNOWN-CRID';

      if (error instanceof HttpErrorResponse) {
        crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
      }
      this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
    }
  }
}
